import React, { PureComponent } from 'react';
import { Image, Popup, Icon, Card } from 'semantic-ui-react';
import { fetchThumbnail } from '../../../utils/thumbnailRecovery';
import Images from '../../../assets/Images';
import './AdLibraryLaunch.css';

class AdLibraryLaunchCard extends PureComponent {
  async componentDidMount() {
    const { adPrototype } = this.props;
    await this.setProperThumbnail(adPrototype);
  }

  async componentDidUpdate(prevProps) {
    const { adPrototype: prevAdPrototype } = prevProps;
    const { adPrototype } = this.props;
    if (prevAdPrototype.id !== adPrototype.id) {
      await this.setProperThumbnail(adPrototype);
    }
  }

  setProperThumbnail = async (adPrototype) => {
    const { fbToken, currentThumbnail } = this.props;
    const { thumbnail, cards } = adPrototype;
    if (currentThumbnail.trim() === '') {
      let thumbnailToUse = thumbnail;
      if (
        !thumbnail ||
        (thumbnail.includes('missingThumbnail' || thumbnail.trim() !== '') &&
          (cards && cards.length > 0))
      ) {
        // this is for aesthetic only. carousel's do not need the main card thumbnail to launch
        // for now, set the carousel thumbnail to the first card's thumbnail
        // if that thumbnail is missing, then the ad won't launch
        const newThumbnail = await fetchThumbnail(cards[0], fbToken);
        thumbnailToUse = newThumbnail;
      }
      this.setCurrentThumbnailState(thumbnailToUse);
    }
  };

  setCurrentThumbnailState = (thumbnail) => {
    const { setStateInGrandparent } = this.props;
    if (setStateInGrandparent) {
      setStateInGrandparent({ currentThumbnail: thumbnail });
    }
  };

  renderAdPrototypePopupContent = () => {
    const { adPrototype } = this.props;
    const {
      title,
      type,
      message,
      footer_text: footerText,
      call_to_action: callToAction
    } = adPrototype;
    return (
      <div>
        {type !== 'Carousel' ? (
          <p>
            <b>Title</b>: {title && title.trim() !== '' ? title : '[Blank]'}
          </p>
        ) : null}
        <p>
          <b>Message</b>:{' '}
          {message && message.trim() !== '' ? message : '[Blank]'}
        </p>
        {type === 'Collection' ? (
          <p>
            <b>Footer Text</b>:{' '}
            {footerText && footerText.trim() !== '' ? footerText : '[Blank]'}
          </p>
        ) : null}

        {type !== 'Canvas' && type !== 'Collection' ? (
          <p>
            <b>CTA</b>:{' '}
            {callToAction && callToAction.trim() !== ''
              ? callToAction
              : '[Blank]'}
          </p>
        ) : null}
      </div>
    );
  };

  render() {
    const { adPrototype, renderTags } = this.props;
    const { daaTypeCard } = Images;
    const { currentThumbnail } = this.props;
    const { type, name, thumbnail } = adPrototype;

    return (
      <Card>
        <br />
        <Image
          className="ad-library-launch-thumbnail"
          src={type !== 'DAA' ? currentThumbnail || thumbnail : daaTypeCard}
        />
        <br />
        <Card.Content textAlign="center">
          <Card.Header
            style={{
              whiteSpace: 'nowrap',
              textOverflow: 'ellipsis',
              overflow: 'hidden'
            }}
          >
            <Popup
              trigger={
                <span>
                  <b>{name}</b>
                </span>
              }
              on="hover"
              content={name}
            />
          </Card.Header>
          <Card.Meta>{type}</Card.Meta>
          <Card.Description>{renderTags(adPrototype)}</Card.Description>
        </Card.Content>
        <Card.Content extra>
          <div style={{ width: '100%' }}>
            <Popup
              position="left center"
              trigger={
                <Icon
                  name="ellipsis horizontal"
                  color="black"
                  size="big"
                  style={{ opacity: 0.5, width: '100%' }}
                />
              }
              content={this.renderAdPrototypePopupContent}
            />
          </div>
        </Card.Content>
      </Card>
    );
  }
}

export default AdLibraryLaunchCard;



// WEBPACK FOOTER //
// ./src/screens/PackageBuilder/AdLibrary/AdLibraryLaunchCard.js